<template>
  <div class="cd_header">
    <p class="courseName">{{ info.courseName }}</p>
    <a-row class="cd_header_layout" :gutter="[20,20]">
      <a-col :xs="24" :sm="24" :md="24" :lg="5" class="sider_left">
        <a-popover placement="right">
            <template slot="content">
              <img
                src="../../assets/imgs/shapes/video-1.jpg"
                class="ewm_box"
                alt=""
              />
            </template>
            <div class="sider_icon_box"><i class="iconfont">&#xe610;</i></div>
          </a-popover>
          <a-popover placement="right">
            <template slot="content">
              <img
                src="../../assets/imgs/shapes/video-1.jpg"
                class="ewm_box"
                alt=""
              />
            </template>
            <div class="sider_icon_box"><i class="iconfont">&#xe60f;</i></div>
          </a-popover>
          <a-popover placement="right">
            <template slot="content">
              <img
                src="../../assets/imgs/shapes/video-1.jpg"
                class="ewm_box"
                alt=""
              />
            </template>
            <div class="sider_icon_box"><i class="iconfont">&#xe882;</i></div>
          </a-popover>
          <a-popover placement="right">
            <template slot="content">
              <img
                src="../../assets/imgs/shapes/video-1.jpg"
                class="ewm_box"
                alt=""
              />
            </template>
            <div class="sider_icon_box"><i class="iconfont">&#xe653;</i></div>
          </a-popover>
      </a-col>
      <a-col :xs="24" :sm="24" :md="24" :lg="14">
        <div class="slick-slide-box">
          <a-carousel :autoplay="true"  :after-change="onChange">
              <div class="course_img"><img src="../../assets/imgs/shapes/about-1.jpg" alt=""></div>
              <div class="course_img"><img src="../../assets/imgs/shapes/about-2.jpg" alt=""></div>
          </a-carousel> 
        </div>
           
      </a-col>
      <a-col :xs="24" :sm="24" :md="24" :lg="5" class="sider_right">
        <div class="course_content" >
                <span v-html="info.courseDesc"></span>
            </div>
            <div class="course_go">
                <div class="course_button">进入课程</div>
            </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
export default {
  props: ["details"],
  watch: {
    details(obj) {
      this.info = obj;
    },
  },
  name: "",
  components: {},
  data() {
    return {
      info: this.details,
    };
  },
  created() {},
  mounted() {},
  methods: {
    onChange(){

    }
  },
};
</script>
<style lang='less' scoped>
@media only screen and (min-width: 991px){ 
  .sider_left{
    flex-direction: column;
    height: 600px;
    padding: 150px 10px !important;

  }
  .course_content{
    height: 500px !important;
  }
}

@media only screen and (max-width: 991px){ 
  .sider_left{
    flex-direction: row;
    height: auto;
  }
  .course_go{
    justify-content: center !important;
  }
  /deep/.ant-carousel{
      height: 100%;
    }
  /deep/.slick-slider{
      height: 100%;
    }
  /deep/.slick-list{
      height: 100%;
    }
}
p{
  margin: 0;
}
.courseDetail {
  width: 100%;
  height: auto;
  .cd_header {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .courseName{
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 24px;
      margin-bottom: 20px;
    }
  .slick-slide-box{
    width: 100%;
    height: 500px;
   
  }
    .sider_left {
      box-sizing: border-box;
      display: flex;
      .sider_icon_box {
        width: 50px;
        height: 50px;
        border: 1px solid #fff;
        border-radius: 50%;
        margin: 20px auto;
        text-align: center;
        line-height: 50px;
        .iconfont {
          color: #fff;
          font-size: 24px;
          cursor: pointer;
        }
      }
    }
    .course_img{
        width: 80%;
        max-height: 600px;
        height: 100%;
        background: #fff;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .sider_right{
           .course_content::-webkit-scrollbar{
              display: none;
          }
        .course_content{
            width: 100%;
            padding: 0px 15px 40px 0;
            box-sizing: border-box;
            max-height: 500px;
            height: auto;
            font-size: 16px;
            color: #fff;
            overflow-y: auto;
            line-height: 25px;
        }
        .course_go{
            width: 100%;
            height: 150px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .course_button{
                width: 60%;
                height: 60px;
                border-radius: 30px;
                border: 2px solid #fff;
                text-align: center;
                line-height: 60px;
                font-size: 24px;
                font-weight: bold;
                color: #fff;
                cursor: pointer;
            }
        }
    }
  }
}
.ewm_box {
  width: 150px;
  height: 150px;
}
</style>
